import { render, staticRenderFns } from "./AddBorrowTable.vue?vue&type=template&id=2704bc56&scoped=true&"
import script from "./AddBorrowTable.vue?vue&type=script&lang=js&"
export * from "./AddBorrowTable.vue?vue&type=script&lang=js&"
import style0 from "./AddBorrowTable.vue?vue&type=style&index=0&id=2704bc56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2704bc56",
  null
  
)

export default component.exports